import React, { useEffect, useState } from 'react';
import { Col, DatePicker, Form, Input, Modal, Row, Select } from 'antd';
import { CONTACT_CENTER_REASONS } from '../../constants';
import useCreateCustomerServiceLog from 'hooks/data/useCreateCustomerServiceLog';
import { IContactCenterLogRequest } from 'interfaces/IContactCenterLogRequest';
import useToastContext from 'hooks/useToastContext';
import axios from 'axios';
import dayjs, { Dayjs } from 'dayjs';
import { RangePickerProps } from 'antd/es/date-picker';
import { IContactCenterLog } from 'interfaces/contact-center-log';


interface ContactCenterLogFormProps {
  open: boolean;
  setRequestLogOpen: (value: boolean) => void;
  onContactCenterAdded:() => void;
  onCancel: () => void;
  log?: IContactCenterLogRequest | undefined;
  cardholder: String
}

const ModalContactCenterLogModal: React.FC<ContactCenterLogFormProps> = ({ open, setRequestLogOpen, onContactCenterAdded, onCancel, log, cardholder}) => {
  const [form] = Form.useForm();

  const {
    createCustomerServiceLog,
    isLoading,
    isError,
  } = useCreateCustomerServiceLog();

  const toast = useToastContext();

  const requestSubmit = async () => {

    form
          .validateFields()
          .then(async (values) => {
            try {
              values.cardholder = cardholder
              const createCardHolderResult = await createCustomerServiceLog(values);
              toast.success('Operacion exitosa!', 'El log se ha creado con exito.');
              onContactCenterAdded()
              form.resetFields();
              setRequestLogOpen(false)
            } catch (error: unknown) {
              form.resetFields();
              if (axios.isAxiosError(error)) {
                toast.error("Algo salió mal", error.response.data)
                console.log(error.response.data)
              } else if (error instanceof Error) {
                // Handle general JS errors
                console.error('General Error:', error.message);
              } else {
                // Handle unknown errors
                console.error('Unknown error', error);
              }
              setRequestLogOpen(false)
            }
          })
          .catch((info) => {
            console.error('Validate Failed:', info);
            setRequestLogOpen(false)
          });
  }

  const disabledDate: RangePickerProps['disabledDate'] = (current: Dayjs) => {
    const afterDay = dayjs().add(1, 'hours');
    return !current.isBefore(afterDay);
  };


  /*
  useEffect(() => {
    form.setFieldValue('date', log?.date);
    form.setFieldValue('reason', log?.reasons);
    form.setFieldValue('observation', log?.observation);
  }, [log]);
  */


  return (
    <Modal
      open={open}
      title={log ? 'Modificar registro' : 'Crear nuevo registro'}
      okText={log ? 'Modificar' : 'Crear'}
      cancelText="Cancelar"
      confirmLoading={isLoading}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => {
          requestSubmit()
      }}
    >
      <Form form={form}
            layout="vertical"
            name="form_in_modal"
            initialValues={{
              date: dayjs(),
            }}
      >
      <Row>
          <Col span={24}>
              <Form.Item<IContactCenterLogRequest>
              name="date"
              label="Fecha"
              rules={[{ required: true, message: 'Por favor seleccionar una fecha.' }]}
            >
            <DatePicker
                showTime
                format="YYYY-MM-DDTHH:mm:ss-03:00"
                disabledDate={disabledDate}
            />
            </Form.Item>
          </Col>
      </Row>
      <Row>
          <Col span={24}>
            <Form.Item<IContactCenterLogRequest>
              name="reasons"
              label="Motivo"
              rules={[{ required: true, message: 'Por favor ingresar pais.' }]}
            >
              <Select
                placeholder="Seleccionar motivo"
                showSearch
                mode="multiple"
                allowClear
                options={CONTACT_CENTER_REASONS.sort().map((reason) => ({ label: reason, value: reason }))}
              />
            </Form.Item>
          </Col>
      </Row>
      <Row>
        <Col span={24}>
         <Form.Item<IContactCenterLogRequest> name="observation" label={'Observacion'}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      </Form>
    </Modal>
  );
};
export default ModalContactCenterLogModal;
